<template>
    <div class="page bgF9F9F9">

        <header class="pageHeader detailPageHeader paddingH16 paddingV8 white_bg">
            <div class="borderLayout">
                <div class="middleRegion">
                    <div class="westRegion" style="width: 60px">
                        <span class="icon leftAngleBracketIcon floatL" style="margin-top: 3px;" @click="back();"></span>
                    </div>
                    <div class="centerRegion alignCenter font18r primaryTextColor bold">
                        {{title}}
                    </div>
                    <div class="eastRegion font14r alignRight" style="width: 60px">
                        <span class="orange bold" @click="save()">确定</span>
                    </div>
                </div>
            </div>
        </header>

        <div class="body marginT4 white_bg">
            <div class="generalPagePaddingH">
                <div class="formRow flexLayout" style="padding: 18px 0 8px;">
                    <div class="columnName" style="width: 82px;">身份证号</div>
                    <div class="columnValue flexItem">
                        <input type="text" class="inputbox block" style="border: 1px solid rgba(187, 187, 187, 100);"
                            placeholder="请输入您的身份证号码" v-model="formData.idCardNumber" @change="updateDataItem(formData)"/>
                    </div>
                </div>
                <div class="formRow" style="padding-bottom: 10px;">
                    <div class="columnName">上传身份证照片</div>
                    <div class="columnValue marginT12">
                        <idCardUploader @changeFrontImage="onChangeFrontImage" @changeBackImage="onChangeBackImage"/>
                    </div>
                    <div class="font14r" style="margin-top: 81px; color: #B7B6B5;">
                        注：身份证认证是基于用户提现时需要进行实名认证，您保证您填写的信息真实有效。
                    </div>
                </div>

            </div>
        </div><!-- end .body -->

    </div>
</template>

<script>
import shixunPagePart from '@/components/shixunApp/shixunPagePart';
import idCardUploader from '@/components/form/idCardUploader';

import appHelper from '@/util/appHelper';

const config = {
    name : 'idCardAuth',
    title : '身份证认证',
    description : '',
    apiConfig : {
        add : {
            url : 'portal/user/user/update/v2021',
            method : 'PUT'
        },
        update : {
            url : 'portal/user/user/update/v2021',
            method : 'PUT'
        },

    }
};

export default {
    name: config.name,
    extends : shixunPagePart,
    components : {
        idCardUploader
    },
    data () {
        return {
            title : config.title,
            description : config.description,
            apiConfig : config.apiConfig,
            formData : {
                idCardNumber : '',
                idCardFront : '',
                idCardBack : '',
            }
        }
    },
    methods : {
        onChangeFrontImage(data) {
            this.formData.idCardFront = data;
            this.updateDataItem(this.formData);
        },
        onChangeBackImage(data) {
            this.formData.idCardBack = data;
            this.updateDataItem(this.formData);
        },
        beforeSubmit(data){
            this.updateDataItem(this.formData);
            data = this.dataItem;
            return data;
        },
        onSubmitSuccess(data, result) {
            if (result.errorCode)
            {
                appHelper.showHint(result.msg);
                return;
            }

            appHelper.showHint('提交成功');
            appHelper.goToPage('me')
        }
    }
}
</script>

<style lang="scss" scoped>
.orange {
    color: #F4950E;
}
.formRow {
    .columnName {
        color: #5B616C;
    }
    .columnValue {
        .inputbox {
            display: block;
            width: 100%;
            font-size: 16px;
            height: 27px;
            line-height: 27px;
            border: none;
            background: transparent;
            color: hsla(0, 0%, 20%, 1);
            outline: none;
        }
        .inputbox::placeholder,
        .inputbox::-webkit-input-placeholder,
        .inputbox::-moz-placeholder,
        .inputbox::-ms-input-placeholder {
            color: hsla(220, 27%, 78%, 1);
        }
    }
}
</style>
